import FacebookIcon from '@mui/icons-material/Facebook';
import { useState } from 'react';

const FacebookButton = ({ post, setShowSocialPost }) => {
  const [fbUserAccessToken, setFbUserAccessToken] = useState();
  const [fbUserId, setFbUserId] = useState();

  const handleFacebook = () => {
    const getPagesTiedWithUser = () => {
      // get pages tied with loggedin user.
      FB.api('/me/accounts', 'GET', {}, function (response) {
        // handle the response, which contains the user's pages
        //console.log(response);
        const pageOptions = response?.data?.map(({ id, name, access_token }) => ({
          value: id,
          label: name,
          accessToken: access_token,
          pageId: id,
        }));
        setShowSocialPost({ selectedNetwork: 'Facebook', pageOptions, ...post });
      });
    };

    FB.getLoginStatus(function (response) {
      if (response.status === 'connected') {
        // The user is logged in and has authenticated your app
        getPagesTiedWithUser();
      } else {
        FB.login(
          (response) => {
            if (response.authResponse) {
              console.log('logged in', response);
              setFbUserAccessToken(response?.authResponse?.accessToken);
              setFbUserId(response?.authResponse?.userID);
              setShowSocialPost({ network: 'Facebook' });
              getPagesTiedWithUser();
            } else {
              console.log('not logged in', response);
            }
          },
          { scope: 'pages_manage_posts, pages_show_list' }
        );
      }
    });
  };

  return (
    <FacebookIcon className="link-feel" fontSize="small" /*onClick={() => handleFacebook()}*/ />
  );
};

export default FacebookButton;
